import { pending } from "@/lib/api";

const MIN_MS = 900;
const MAX_MS = 10000;

const inView = (img) => {
  const r = img.getBoundingClientRect();
  return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
};

const imagesDone = () => [...document.images].filter((img) => img.loading !== "lazy" || inView(img)).every((img) => img.complete);

export function hideSplashWhenReady() {
  const splash = document.getElementById("lp-splash");
  if (!splash) return;
  const start = Date.now();
  let stable = 0;
  const hide = () => {
    splash.classList.add("lp-hide");
    setTimeout(() => splash.remove(), 600);
  };
  const check = () => {
    const elapsed = Date.now() - start;
    const ready = document.readyState === "complete" && pending.count === 0 && imagesDone();
    stable = ready ? stable + 1 : 0;
    if ((stable >= 3 && elapsed >= MIN_MS) || elapsed >= MAX_MS) {
      (document.fonts?.ready || Promise.resolve()).then(hide);
      return;
    }
    setTimeout(check, 150);
  };
  check();
}
